const getAuthorizations = async (id) => {
    try {
        const data = await ApiClient.get(`/staffs/${id}/authorizations`);
        return data.data;
    } catch (error) {
        console.error(error);
        throw new Error(error.message);
    }
};

const revokeAuthorization = async (uuid) => {
    try {
        const response = await ApiClient.del(`/masquerade/authorizations/${uuid}`);

        if (response.status === 204) {
            return 'success';
        } else {
            console.error(response.statusText);
            throw new Error(response.statusText);
        }
    } catch (error) {
        console.error(error);
        throw new Error(error.message);
    }
};

const acceptAuthorization = async (uuid) => {
    try {
        const response = await ApiClient.post(`/masquerade/authorizations/${uuid}/consent`);

        if (response.status === 204) {
            return 'success';
        } else {
            console.error(response.statusText);
            throw new Error(response.statusText);
        }
    } catch (error) {
        console.error(error);
        throw new Error(error.message);
    }
};

const refuseAuthorization = async (uuid) => {
    try {
        const response = await ApiClient.post(`/masquerade/authorizations/${uuid}/refuse`);

        if (response.status === 204) {
            return 'success';
        } else {
            console.error(response.statusText);
            throw new Error(response.statusText);
        }
    } catch (error) {
        console.error(error);
        throw new Error(error.message);
    }
};

const requestConsent = async (formData) => {
    try {
        const response = await ApiClient.post('/staffs/authorizations', {}, formData);

        if (response.status === 201) {
            return 'success';
        } else {
            console.error(response.statusText);
            throw new Error(response.statusText);
        }
    } catch (error) {
        console.error(error);
        throw new Error(error.message);
    }
};

const downloadLogs = (type) => {
    const error = window.i18n.__(
        'Un problème est survenu lors du téléchargement. Veuillez réessayer plus tard.',
    );
    return new Promise((resolve, reject) => {
        ApiClient.post(`/masquerade/logs/export/${type}`, {}, {})
            .then(() => {
                resolve('success');
            })
            .catch(() => {
                reject(error);
            });
    });
};

export {
    getAuthorizations,
    revokeAuthorization,
    acceptAuthorization,
    refuseAuthorization,
    requestConsent,
    downloadLogs,
};
